import React from 'react';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Link} from '@mui/material';
import {
  PromotionListItem,
  getPromotionFormattedDateRange,
} from '@practicegenius/domain/src/data/promotions/promotion';

type Props = {
  promotion: PromotionListItem;
  cardSize?: 'small' | 'large';
};

/** Promotion card display
 * - promotion - the promotion to display
 * - cardSize - optional, the size of the card (small or large) defaults to small
 */
export const PromotionCard: React.FC<Props> = ({
  promotion,
  cardSize = 'small',
}) => {
  // There should be no card displayed in the off chance that there is no url
  if (!promotion.url) return null;

  return (
    <Link
      sx={{height: 'auto', border: 'none', textDecoration: 'none'}}
      href={promotion.url}
      data-no-ajax-load-page="true"
    >
      <CardMedia
        sx={{paddingTop: `${(9 / 16) * 100}%`}}
        image={promotion.image}
      />
      <CardContent
        sx={{
          height: cardSize === 'small' ? 120 : undefined,
          paddingTop: '12px',
        }}
      >
        <Typography
          gutterBottom
          variant="overline"
          component="p"
          color="textSecondary"
          sx={{lineHeight: 1.2, fontSize: cardSize === 'small' ? 12 : 18}}
        >
          {getPromotionFormattedDateRange(promotion)}
        </Typography>
        <Box
          sx={{height: cardSize === 'small' ? 75 : undefined, width: '100%'}}
        >
          <Typography
            variant="h6"
            color="textPrimary"
            sx={{
              fontWeight: 600,
              lineHeight: 1.2,
              fontSize: cardSize === 'small' ? 20 : 28,
              py: cardSize === 'small' ? 0 : 2,
              overflow: 'hidden',
              textOverflow: 'ellipsis',

              // This works for all browsers other than <=IE11
              display: '-webkit-box',
              WebkitLineClamp: cardSize === 'small' ? 3 : undefined,
              '-webkit-box-orient': 'vertical',
            }}
          >
            {promotion.title}
          </Typography>
        </Box>
      </CardContent>
    </Link>
  );
};
